 

/**
 * systemRegistry.js
 *
 * Maps a system id to its local config file. Bootstrap looks up this
 * registry once, by id, to merge local metadata (brandIcon,
 * defaultModule, footerNote) with whatever the backend returned. To
 * introduce system #5 you add one config file + one line here — no
 * component ever needs an `if (systemId === '...')` branch.
 */
const doctorConfig =  {
  id: "docteur",
  brandIcon: "🩺",
  defaultModule: "acceuil",
  footerNote: "Doctor ERP · Clinical Suite",
} ;
const shopConfig = {
  id: "magazin",
  brandIcon: "🛍️",
  defaultModule: "acceuil",
  footerNote: "Shop ERP · Retail Suite",
} ;
const restaurantConfig =   {
  id: "restaurant",
  brandIcon: "🍽️",
  defaultModule: "acceuil",
  footerNote: "Restaurant ERP · Hospitality Suite",
};
const taxiConfig =  {
  id: "autoecole",
  brandIcon: "🚕",
  defaultModule: "acceuil",
  footerNote: "Taxi ERP · Fleet Suite",
};

const SYSTEM_REGISTRY = {
  doctor: doctorConfig,
  shop: shopConfig,
  restaurant: restaurantConfig,
  taxi: taxiConfig,
};

export function getSystemConfig(systemId) {
  return (
    SYSTEM_REGISTRY[systemId] ?? {
      id: systemId,
      brandIcon: '⚙️',
      defaultModule: null,
      footerNote: '',
    }
  );
}
